import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Capacitor } from '@capacitor/core';
import logo from '../../assets/logo.png';

const APP_STORE_URL = 'https://apps.apple.com/app/id6793319189';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.ansim.seoul';

/**
 * 모바일 웹 브라우저에서만 표시되는 앱 다운로드 유도 배너.
 * Capacitor 네이티브 앱 환경에서는 렌더링하지 않음.
 */
export default function AppDownloadBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // 네이티브 앱이면 표시하지 않음
    if (Capacitor.isNativePlatform()) return;

    // 이미 닫은 경우 표시하지 않음
    if (sessionStorage.getItem('bannerDismissed')) return;

    setVisible(true);
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem('bannerDismissed', '1');
    setVisible(false);
  };

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 'env(safe-area-inset-top)',
      left: 0,
      right: 0,
      zIndex: 9999,
      background: 'linear-gradient(135deg, #0f2c54, #1a3d6b)',
      color: 'white',
      padding: '10px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.25)',
    }}>
      {/* 앱 아이콘 */}
      <img
        src={logo}
        alt="안심IN서울"
        style={{ width: 40, height: 40, borderRadius: 10, flexShrink: 0 }}
      />

      {/* 텍스트 */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: 0, fontWeight: 700, fontSize: '0.875rem', color: 'inherit' }}>안심IN서울</p>
        <p style={{ margin: '2px 0 0', fontSize: '0.75rem', color: 'inherit', opacity: 0.85 }}>
          앱으로 더 편리하게 사용하세요
        </p>
      </div>

      {/* 다운로드 버튼 */}
      <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
        {(isIOS || (!isIOS && !isAndroid)) && (
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            id="btn-appstore-banner"
            style={{
              background: 'white',
              color: '#0f2c54',
              borderRadius: 8,
              padding: '6px 10px',
              fontSize: '0.7rem',
              fontWeight: 700,
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            🍎 App Store
          </a>
        )}
        {(isAndroid || (!isIOS && !isAndroid)) && (
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            id="btn-googleplay-banner"
            style={{
              background: 'white',
              color: '#0f2c54',
              borderRadius: 8,
              padding: '6px 10px',
              fontSize: '0.7rem',
              fontWeight: 700,
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            🤖 Google Play
          </a>
        )}
      </div>

      {/* 닫기 */}
      <button
        onClick={handleDismiss}
        id="btn-banner-dismiss"
        aria-label="배너 닫기"
        style={{
          background: 'rgba(255,255,255,0.15)',
          border: 'none',
          borderRadius: '50%',
          width: 28,
          height: 28,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          flexShrink: 0,
          color: 'white',
        }}
      >
        <X size={14} />
      </button>
    </div>
  );
}
